'use client';

import { AuthProvider } from '@/contexts/AuthContext';
import { AdRotationProvider } from '@/components/ads/AdRotationProvider';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <AdRotationProvider>
        {children}
      </AdRotationProvider>
    </AuthProvider>
  );
}